import React, { useEffect, useState, useRef } from 'react';
import StatusToggle from './StatusToggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPlug, faPencilAlt, faTimes, faCheck} from '@fortawesome/free-solid-svg-icons';

export default function Outlet({outlet, pduName, api, user}) {

  const isInitialMount = useRef(true);
  const [highlightName, setHighlightName] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(outlet.name);
  const initialGroupId = outlet.group ? outlet.group.id : -1;
  const [groupId, setGroupId] = useState(initialGroupId);

  useEffect(() => {
    if (isInitialMount.current) {
       isInitialMount.current = false;
    } else {
      setHighlightName(true);
      setTimeout(() => {
        setHighlightName(false);
      }, 2000);
    }
  }, [outlet.name]);

  async function setPowerstate(newValue) {
    return await api.setPowerstate(outlet.id, outlet.outletId, pduName, newValue);
  }

  async function updateOutlet() {
    let data = {};
    if(name != outlet.name) {
      data.name = name;
    }
    if(groupId != initialGroupId) {
      data.group_id = groupId;
    }
    if(data == {}) return;
    return await api.updateOutlet(outlet.id, outlet.outletId, pduName, data);
  }

  function editOutlet() {
    setEditMode(true);
  }

  function cancelEdits() {
    setName(outlet.name);
    setGroupId(initialGroupId);
    setEditMode(false);
  }

  function confirmEdits() {
    setEditMode(false);
    updateOutlet();
  }

  function updateName(evt) {
    setName(evt.target.value);
  }

  function updateGroupId(evt) {
    setGroupId(evt.target.value);
  }

  if(editMode) {
    return <form onSubmit={confirmEdits} className="Outlet list-group-item form-inline" key={`outlet_${outlet.id}`}>
      <span className="Outlet-id badge badge-primary">{outlet.outletId}</span>
      <div className="input-group Outlet-name p-2">
        <input className="form-control" type="text" value={name} onChange={updateName} placeholder="Outlet Name"></input>
      </div>
      <div className="input-group p-2">
        <select className="form-control" value={groupId} onChange={updateGroupId}>
          <option value="-1">No Group</option>
          {api.data.groups != null ? api.data.groups.map(g => <option value={g.id}>{g.name}</option>) : <option value={outlet.group.id}>Error: No groups found</option>}
        </select>
      </div>
      <button type="button" onClick={cancelEdits} className={`Outlet-menu btn btn-danger`}><FontAwesomeIcon className="Outlet-icon" icon={faTimes} title="Cancel" /></button>
      <button type="submit" className={`Outlet-menu btn btn-success`}><FontAwesomeIcon className="Outlet-icon" icon={faCheck} title="Cancel" /></button>
    </form>
  }

  return <div className="Outlet list-group-item">
    <span className="Outlet-id badge badge-primary">{outlet.outletId}</span>
    <span className={`Outlet-name ${highlightName ? 'is-highlighted' : ''}`}>{outlet.name}</span>
    <span className="Outlet-group badge badge-secondary font-weight-normal">{outlet.group ? outlet.group.name : 'No Group'}</span>
    {user.accessLevel >= 2 && <button onClick={editOutlet} className="Outlet-menu btn btn-secondary"><FontAwesomeIcon className="Outlet-icon" icon={faPencilAlt} title="Edit Outlet" /></button>}
    {!outlet.reachable && <FontAwesomeIcon className="Outlet-icon text-danger" icon={faPlug} title="Outlet is unreachable" />}
    <span className="Outlet-powerstate text-right">
      <StatusToggle key={`outlet_${outlet.id}_powerstate`} className="ml-auto" title={outlet.reachable ? '' : 'Outlet is unreachable'} disabled={!outlet.reachable} trackedValue={outlet.powerstate} toggleFunction={setPowerstate}></StatusToggle>
    </span>
  </div>
}
